module.exports = [
  {
    path: '/',
    pattern: /^(?:\/(?=$))?$/i,
    keys: [],
    page: './pages/home',
    load: function load() { return Promise.resolve(require('./pages/home')); },
  },
  {
    path: '/error',
    pattern: /^\/error(?:\/(?=$))?$/i,
    keys: [],
    page: './pages/error',
    load: function load() { return Promise.resolve(require('./pages/error')); },
  },
  {
    path: '/about',
    pattern: /^\/about(?:\/(?=$))?$/i,
    keys: [],
    page: './pages/about',
    load: function load() { return new Promise(function (resolve, reject) {
        try {
          require.ensure(['./pages/about'], function (require) {
            resolve(require('./pages/about'));
          });
        } catch (err) {
          reject(err);
        }
      }); },
  },
  {
    path: '/tasks/:status(pending|completed)?',
    pattern: /^\/tasks(?:\/((?:pending|completed)))?(?:\/(?=$))?$/i,
    keys: [{"name":"status","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"pending|completed"}],
    page: './pages/home',
    load: function load() { return new Promise(function (resolve, reject) {
        try {
          require.ensure(['./pages/home'], function (require) {
            resolve(require('./pages/home'));
          });
        } catch (err) {
          reject(err);
        }
      }); },
  },
  {
    path: '/catalog/:catalogId',
    pattern: /^\/catalog\/((?:[^\/]+?))(?:\/(?=$))?$/i,
    keys: [{"name":"catalogId","prefix":"/","delimiter":"/","optional":false,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: './pages/catalog',
    load: function load() { return Promise.resolve(require('./pages/catalog')); },
  },
  {
    path: '/catalog/:catalogId/:productId',
    pattern: /^\/catalog\/((?:[^\/]+?))\/((?:[^\/]+?))(?:\/(?=$))?$/i,
    keys: [{"name":"catalogId","prefix":"/","delimiter":"/","optional":false,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"},{"name":"productId","prefix":"/","delimiter":"/","optional":false,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: './pages/catalog',
    load: function load() { return Promise.resolve(require('./pages/catalog')); },
  },
  {
    path: '/catalog',
    pattern: /^\/catalog(?:\/(?=$))?$/i,
    keys: [],
    page: './pages/catalog',
    load: function load() { return Promise.resolve(require('./pages/catalog')); },
  },
];


/*****************
 ** WEBPACK FOOTER
 ** ./routes.json
 ** module id = 688
 ** module chunks = 0
 **/